import TriggerView from "../view/trigger.js";

import ScrollToElement from "../../scroll-to-element/scroll-to-element.js";

export default class AnchorScroll {
  constructor() {
    this._views = [];

    this._scrollToElement = new ScrollToElement();

    this._handleTriggerClick = this._handleTriggerClick.bind(this);
  }

  init() {
    const triggers = document.querySelectorAll(`[href^="#"]`);
    Array.from(triggers)
      .forEach((trigger) => {
        const view = new TriggerView(trigger);
        view.setClickHandler(this._handleTriggerClick);

        this._views.push(view);
      });
  }

  _handleTriggerClick(targetElement) {
    if (!targetElement) {
      console.error(`The target element has not been defined!`);
      return;
    }

    this._scrollToElement.scroll({
      element: targetElement
    });
  }
}
